import type { ThunkAction, UnknownAction } from '@reduxjs/toolkit'
import { errorView, isTransportError, type TransportError } from '@krp/client-runtime'
import { verifyPosCashier } from '../api/cashierAccessCommand'
import { accessKeyOf, cashierLocked, checkFailed, checkStarted, codeWrong, proofGranted } from './cashierAccessSlice'

// Одна проверка на кассира и store; PIN существует только в замыкании thunk и теле запроса.
const pending = new WeakMap<object, Set<string>>()
function detail(error: TransportError, field: string): number | null {
  const value = error.details?.[field]
  return typeof value === 'number' && Number.isFinite(value) ? value : null
}
export function cashierVerifyRequested({ resourceId, cashierId, credential }: { resourceId: string; cashierId: string; credential: string }): ThunkAction<Promise<void>, unknown, unknown, UnknownAction> {
  return async (dispatch, getState, extra) => {
    let requests = pending.get(dispatch)
    if (requests === undefined) { requests = new Set(); pending.set(dispatch, requests) }
    const key = accessKeyOf(resourceId, cashierId)
    if (credential.trim() === '' || requests.has(key)) return
    requests.add(key)
    dispatch(checkStarted({ resourceId, cashierId }))
    const refuse = (error: unknown) => {
      const view = errorView(error)
      if (view.code === 'cashier-credential-wrong') dispatch(codeWrong({ resourceId, cashierId, attemptsLeft: isTransportError(error) ? detail(error, 'attemptsLeft') : null }))
      else if (view.code === 'cashier-locked' || view.code === 'cashier-credential-locked') {
        const seconds = isTransportError(error) ? detail(error, 'retryAfterSeconds') ?? 300 : 300
        dispatch(cashierLocked({ resourceId, cashierId, lockedUntil: new Date(Date.now() + seconds * 1000).toISOString() }))
      } else dispatch(checkFailed({ resourceId, cashierId, message: view.message }))
    }
    try {
      const result = await verifyPosCashier({ resourceId, sourceCashierId: cashierId, credential, purpose: 'pos' })(dispatch, getState, extra)
      if (!result.ok) { refuse(result.error); return }
      dispatch(proofGranted({ resourceId, cashierId, proof: result.data.grant, expiresAt: result.data.expiresAt }))
    } catch (error) {
      refuse(error)
    } finally { requests.delete(key) }
  }
}
